import { message } from "antd";
import { IoCopyOutline } from "react-icons/io5";

export const MissionDisplay = ({ mission }) => {
  const handleCopy = async (props) => {
    const text = (props || "")
      .split(",")
      .map((tag) => tag.trim())
      .filter(Boolean)
      .join(" ");

    try {
      await navigator.clipboard.writeText(text);
      message.success("복사되었습니다.");
    } catch (error) {
      message.error("복사에 실패했습니다.");
    }
  };

  return (
    <div>
      {Array.isArray(mission) && mission.length > 0 ? (
        mission.map((m, i) => (
          <div key={i}>
            {(m?.title === "해시태그" || m?.title === "계정태그") && (
              <div>
                <div className="flex items-center mb-5 gap-2">
                  {m?.title && <div className="font-medium">{m.title}</div>}
                  <IoCopyOutline
                    className="cursor-pointer"
                    size={14}
                    onClick={() => handleCopy(m?.desc)}
                  />
                </div>
                <div className="bg-[#f9f9f9] p-5 rounded-lg space-y-5 mb-4">
                  <span className="text-slate-700 text-[13px] leading-relaxed">
                    {(m?.desc || "")
                      .split(",")
                      .map((tag) => tag.trim())
                      .filter(Boolean)
                      .join(" ")}
                  </span>
                </div>
              </div>
            )}
            {m?.title !== "해시태그" && m?.title !== "계정태그" && (
              <div>
                {m?.title && (
                  <h4 className="text-[14px] font-semibold text-slate-800 m-0 mb-5">
                    {m.title}
                  </h4>
                )}
                <div className="bg-[#f9f9f9] p-5 rounded-lg space-y-5 mb-4">
                  <p
                    className="text-slate-700 text-xl leading-relaxed m-0"
                    dangerouslySetInnerHTML={{
                      __html: (m?.desc || "").replace(/\n/g, "<br/>"),
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        ))
      ) : (
        <p className="m-0">-</p>
      )}
    </div>
  );
};
